import { Card, Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import {
  IoCalendarOutline,
  IoCheckmarkCircleOutline,
  IoMegaphoneOutline,
  IoPeopleOutline,
} from "react-icons/io5";

interface CampaignStatsProps {
  totalCampaigns: number;
  activeCampaigns: number;
  scheduledThisMonth: number;
  totalRecipients: number;
  monthLabel: string;
  onScheduledClick?: () => void;
}

const statCards = [
  {
    key: "total",
    label: "Total Campaigns",
    icon: IoMegaphoneOutline,
    accent: "#19222E",
    bg: "rgba(25, 34, 46, 0.06)",
  },
  {
    key: "active",
    label: "Active Campaigns",
    icon: IoCheckmarkCircleOutline,
    accent: "#198754",
    bg: "rgba(25, 135, 84, 0.08)",
  },
  {
    key: "scheduled",
    label: "Scheduled This Month",
    icon: IoCalendarOutline,
    accent: "#0d6efd",
    bg: "rgba(13, 110, 253, 0.08)",
  },
  {
    key: "recipients",
    label: "Total Recipients",
    icon: IoPeopleOutline,
    accent: "#6f42c1",
    bg: "rgba(111, 66, 193, 0.08)",
  },
] as const;

const CampaignStats = ({
  totalCampaigns,
  activeCampaigns,
  scheduledThisMonth,
  totalRecipients,
  monthLabel,
  onScheduledClick,
}: CampaignStatsProps) => {
  const values = {
    total: totalCampaigns,
    active: activeCampaigns,
    scheduled: scheduledThisMonth,
    recipients: totalRecipients,
  };

  return (
    <Row className="g-3 mb-4">
      {statCards.map((card) => {
        const Icon = card.icon;
        const value = values[card.key];

        return (
          <Col key={card.key} lg={6} xl={3}>
            <Card
              className="h-100 border-0 shadow-sm"
              style={{ borderRadius: "12px", overflow: "hidden" }}
            >
              <Card.Body className="p-3">
                <div className="d-flex align-items-start justify-content-between gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: "10px",
                      backgroundColor: card.bg,
                      color: card.accent,
                    }}
                  >
                    <Icon size={22} />
                  </div>
                  <div className="text-end flex-grow-1 min-w-0">
                    <div
                      className="fw-semibold mb-0"
                      role={card.key === "scheduled" && onScheduledClick ? "button" : undefined}
                      tabIndex={card.key === "scheduled" && onScheduledClick ? 0 : undefined}
                      onClick={
                        card.key === "scheduled" && onScheduledClick
                          ? onScheduledClick
                          : undefined
                      }
                      onKeyDown={
                        card.key === "scheduled" && onScheduledClick
                          ? (event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                onScheduledClick();
                              }
                            }
                          : undefined
                      }
                      style={{
                        fontSize: "1.75rem",
                        color: "#19222E",
                        lineHeight: 1.1,
                        cursor:
                          card.key === "scheduled" && onScheduledClick ? "pointer" : undefined,
                        textDecoration:
                          card.key === "scheduled" && onScheduledClick ? "underline" : undefined,
                        textUnderlineOffset: 4,
                      }}
                    >
                      <CountUp duration={0.8} end={value} />
                    </div>
                    <div
                      className="text-muted text-truncate"
                      style={{ fontSize: "13px", marginTop: "4px" }}
                    >
                      {card.label}
                    </div>
                    {card.key === "scheduled" && (
                      <div style={{ fontSize: "12px", color: card.accent, marginTop: "2px" }}>
                        {monthLabel}
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default CampaignStats;
